import { api } from "./rtkApi";

export const podcastApi = api.injectEndpoints({
	endpoints: (build) => ({
		getPodcasts: build.query({
			query: ({ idCategorie, offset, limit }) => {
				return {
					method: "GET",
					url: `/podcasts/list?idCategorie=${idCategorie}&offset=${offset}&limit=${limit}`,
				};
			},
		}),
		getPodcast: build.query({
			query: ({ slug }) => {
				return {
					method: "GET",
					url: `/podcasts/get/${slug}`,
				};
			},
		}),
		getPodcastVideo: build.query({
			query: ({ id, authToken }) => {
				return {
					method: "GET",
					headers: {
						authorization: "Bearer " + authToken,
						"Content-Type": "application/json",
					},
					url: `/podcasts/get-video/${id}`,
				};
			},
		}),
	}),
	overrideExisting: true,
});

export const { useGetPodcastsQuery, useLazyGetPodcastQuery, useLazyGetPodcastVideoQuery } = podcastApi;
